export default {
  A1() {
    return 'KUESIONER'
  },
  A2() {
    return 'Pertanyaan wajib, mohon dijawab'
  },
  A3(num: number) {
    return `Paling sedikit ${num} jawaban`
  },
  A4(num: number) {
    return `Paling banyak ${num} jawaban`
  },
  A5() {
    return `Silakan isi konten setelah pilihan 'Lainnya'`
  },
  A6(num: number) {
    return `Tidak kurang dari ${num} kata`
  },
  A7() {
    return `Kata-kata untuk jawaban tidak mencukupi`
  },
  A8() {
    return `Melebihi jumlah kata maksimum`
  },
  A9(num: number) {
    return `Bintang ${num}`
  },
  A10() {
    return `Netral`
  },
  A11() {
    return `Terima kasih telah mengisi, kami telah menyiapkan hadiah untuk Anda!`
  },
  A12() {
    return `Sebelumnya`
  },
  A13() {
    return `Berikutnya`
  },
  A14(num: number) {
    return `Pertanyaan ${num}`
  },
  A15() {
    return `Anda telah mengklaim hadiah Anda, klik Keluar untuk kembali ke game.`
  },
  A16() {
    return `Keluar`
  },
  A17() {
    return `Lainnya`
  },
  A20() {
    return `Tentu`
  },
  A21() {
    return `Batal`
  },
  A25() {
    return `Silakan masukkan`
  },
  B(key: keyof ReturnType<typeof getInfomationMap>) {
    return getInfomationMap()[key]
  },
  A26() {
    return 'Aktivitas telah berakhir'
  },
}

function getInfomationMap() {
  return {
    gender: 'jenis kelamin',
    age: 'usia',
    degree: 'gelar',
    city: 'kota',
    career: 'karir',
    income: 'pendapatan',
    interest: 'minat',
    marital_status: 'status perkawinan',
    family_members: 'anggota keluarga',
    personality: 'kepribadian',
    faith: 'keyakinan',
    real_name: 'nama asli',
    phone: 'telepon',
    email: 'email',
    sport: 'olahraga',
    book: 'buku',
    movie: 'film',
    music: 'musik',
    star: 'bintang',
    interest_city: 'kota yang menarik',
    interest_country: 'negara bunga',
    color: 'warna',
    season: 'musim',
    plant: 'tanaman',
    animal: 'binatang',
  }
}
